import { Label, TextStyle } from '@lannister/duplo';

import "./styles.css";

const InfoRow = ({ label, value, textStyle = TextStyle.LargeRegular}) => (
    <div className="info-row">
        <div className="label-wrapper">
            <Label labelText={label} textStyle={textStyle} wrap={true}/>
        </div>
        <div className="value-wrapper">
            <Label labelText={value} textStyle={textStyle} wrap={true}/>
        </div>
    </div>
);

export default InfoRow;
